export default __webpack_public_path__ + "static/media/step_011.a539def2.png";